export const JobPage = (function () {
	'use strict';

	function init() {

		// const ajaxSource = 'https://razr.wpengine.com'

		const modalBanner = document.querySelector('#careers-modal-banner')
		const modalText = document.querySelector('[data-job-ajax]')
		const jobMatch = window.location.href.match(/\/job\/([\-\da-z]+)\/$/)
		const pxMain = document.querySelector('#pxMainContent')

		const data = {}
		if (!modalText || !jobMatch) {
			return
		}

		const jobSlug = jobMatch[1]

		const show = () => {
			if (data[jobSlug]) {
				const job = data[jobSlug]
				modalBanner.querySelector('h1').innerText = job.title
				modalText.innerHTML = job.content
				setTimeout(() => {
					pxMain.classList.add('ready')
				}, 60)
			} else {
				window.location.href = window.location.origin + '/careers/'
			}
		}

		const onData = (resp) => {
			resp.forEach((listing) => {
				data[listing.slug] = {
					title: listing.title,
					content: listing.content
				}
			})
			show()
			window.dispatchEvent(new Event('px-content-added'))
		}
		$.getJSON(`/wp-content/themes/rmi/jobs-ajax.php`, onData)

		const onMeta = (resp) => {
			document.getElementsByTagName('title')[0].remove()
			// const yoastRegex = /<!-- This site is optimized with the Yoast(\n|.)+<!-- \/ Yoast SEO plugin. -->/gi
			const yoastRegex = /<meta name="robots"(\n|.)+]}<\/script>/gmi
			document.head.innerHTML = document.head.innerHTML.replace(yoastRegex, resp.html)
		}
		$.getJSON(`/wp-content/themes/rmi/job-meta-ajax.php?job=${jobSlug}`, onMeta)

	}

	return {
		init: init
	};
})();
